"use strict";

const SOURCE = 'imshop-chat-widget';
const LOADER_ORIGIN = 'https://b3390c28-24b4-4e4b-af17-ae1d7620d7c1.selcdn.net';
const CHAT_ROOT_ID = 'imshop-chat-widget-root';
//Те же bottom, что в imshop-ai-widget.scss. body снаружи shadow не матчится, поэтому :host-context
const FLOATING_BTN_CSS = '@media (min-width: 992px){'
	+ '.imshop-cw-floating-btn{bottom:100px !important}'
	+ '}'
	+ '@media (max-width: 991.98px){'
	+ '.imshop-cw-floating-btn{bottom:calc(150px + env(safe-area-inset-bottom, 0px)) !important}'
	+ ':host-context(body.sticky-buy) .imshop-cw-floating-btn{bottom:calc(215px + env(safe-area-inset-bottom, 0px)) !important}'
	+ '}'
	+ '@media (max-width: 575.98px){'
	+ ':host-context(body.sticky-buy) .imshop-cw-floating-btn{bottom:calc(207px + env(safe-area-inset-bottom, 0px)) !important}'
	+ '}';

//Плашка на хосте .imshop-icebreakers. Типографика: var(--trimiata-ib-*) из _style text-l/m medium
//Desktop lg(992+): wrap без scroll (сброс inline minWidth трека). Mobile: горизонтальный scroll виджета
const ICEBREAKER_CSS = '.imshop-ib-widget{padding:0!important;overflow:visible!important;background:transparent!important;'
	+ 'color:var(--black-tints-800)!important;font-family:var(--font-stack)!important}'
	+ '.imshop-ib-title{margin:0!important;color:var(--black-tints-800)!important;font-family:inherit!important;'
	+ 'font-weight:var(--trimiata-ib-title-fw,500)!important;font-size:var(--trimiata-ib-title-fs,1.125rem)!important;'
	+ 'line-height:var(--trimiata-ib-title-lh,1.5rem)!important;letter-spacing:var(--trimiata-ib-title-ls,-.005625rem)!important}'
	+ '.imshop-ib-hint{color:var(--black-tints-800)!important;font-family:inherit!important;'
	+ 'font-weight:var(--trimiata-ib-hint-fw,500)!important;font-size:var(--trimiata-ib-hint-fs,1rem)!important;'
	+ 'line-height:var(--trimiata-ib-hint-lh,1.25rem)!important;letter-spacing:var(--trimiata-ib-hint-ls,-.005rem)!important}'
	+ '@media (min-width:992px){'
	+ '.imshop-ib-list{overflow:visible!important;width:100%!important;max-width:100%!important}'
	+ '.imshop-ib-track{min-width:0!important;width:100%!important;max-width:100%!important;flex-wrap:wrap!important;'
	+ 'column-gap:.5rem!important;row-gap:.5rem!important}'
	+ '}'
	+ '@media (max-width:991.98px){'
	+ '.imshop-ib-list{overflow-x:auto!important;overflow-y:hidden!important}'
	+ '.imshop-ib-track{flex-wrap:nowrap!important}'
	+ '}';

/**
 * postMessage AI-виджета ImShop. Статический модуль основного бандла.
 */
export const AppAiWidget = {

	/**
	 * @param {Object} app
	 */
	init(app) {
		//Флаг ставит PHP-бутстрап (ru AND admin) — IsAdmin в JS не дублируем
		if (!window.__trimiataAiEnabled) return;
		if (window.__trimiataAiWidgetBound) return;

		window.__trimiataAiWidgetBound = true;
		this.pinFloatingButton();
		window.addEventListener('message', (event) => {
			this.onMessage(app, event);
		});
	},

	/**
	 * Виджет крепит кнопку и айсбрекеры в closed shadow, страничный CSS туда не доходит.
	 * Стили дописываем в shadowRoot хоста после его создания.
	 * @return {void}
	 */
	pinFloatingButton() {
		if (window.__trimiataAiFloatingPin) return;

		window.__trimiataAiFloatingPin = true;
		let native = Element.prototype.attachShadow;
		Element.prototype.attachShadow = function (init) {
			let root = native.call(this, init);
			let parent = this.parentElement;
			if (!parent) return root;

			if (parent.id === CHAT_ROOT_ID) {
				queueMicrotask(() => {
					if (root.querySelector('[data-trimiata-ai-offset]')) return;

					let style = document.createElement('style');
					style.setAttribute('data-trimiata-ai-offset', '');
					style.textContent = FLOATING_BTN_CSS;
					root.appendChild(style);
				});
			} else if (parent.hasAttribute('data-imshop-icebreakers')) {
				queueMicrotask(() => {
					if (root.querySelector('[data-trimiata-icebreakers]')) return;

					let style = document.createElement('style');
					style.setAttribute('data-trimiata-icebreakers', '');
					style.textContent = ICEBREAKER_CSS;
					root.appendChild(style);
				});
			}

			return root;
		};
	},

	/**
	 * @param {Object} app
	 * @param {MessageEvent} event
	 */
	onMessage(app, event) {
		if (!window.__trimiataAiWidget) return;
		if (app.isDev() || app.isDevDomain()) console.log('AppAiWidget postMessage', event.data);

		let data = event.data;
		if (typeof data === 'string') {
			try {
				data = JSON.parse(data);
			} catch (e) {
				return;
			}
		}
		if (!data || typeof data !== 'object' || Array.isArray(data)) return;
		if (data.source !== SOURCE) return;
		if (event.origin !== window.location.origin && event.origin !== LOADER_ORIGIN) return;

		let payload = data.payload && typeof data.payload === 'object' && !Array.isArray(data.payload) ? data.payload : data;
		let action = typeof data.action === 'string' && data.action.length ? data.action : payload.action;

		switch (action) {
			case 'add_to_cart':
				this.addToCart(app, payload);
				break;
			case 'open_cart':
				window.location.href = '/cart/';
				break;
			case 'open_order':
				this.openOrder(app, payload);
				break;
			case 'post_message':
				this.onPostMessage(data);
				break;
			default:
				return;
		}
	},

	/**
	 * @param {Object} app
	 * @param {Object} payload
	 */
	addToCart(app, payload) {
		if ('configurationId' in payload && payload.configurationId.length) {
			app.addToBasket(0, undefined, 1, payload.configurationId)
				.then((result) => {
					if (!result || !result.success) return;

					document.dispatchEvent(new CustomEvent('basketItemAdded', {
						detail: {
							offerId: result.productId,
							headerHtml: result.headerHtml,
							accountMenuHtml: result.accountMenuHtml,
						}
					}));
					app.showToast(app.getMessage('basketItemAdded'));

					if ((result.headerHtml && result.headerHtml.length) || (result.accountMenuHtml && result.accountMenuHtml.length)) {
						document.dispatchEvent(new CustomEvent('smallBasketLoaded', {
							detail: {
								headerHtml: result.headerHtml,
								accountMenuHtml: result.accountMenuHtml,
							}
						}));
					}
				})
				.catch(() => {
				});
		}
	},

	/**
	 * @param {Object} app
	 * @param {Object} payload
	 */
	openOrder(app, payload) {
		let orderId = payload.orderId;
		if (typeof orderId === 'number' && Number.isFinite(orderId)) orderId = String(orderId);
		if (typeof orderId !== 'string') return;

		orderId = orderId.trim();
		if (!/^[0-9A-Za-z-]+$/.test(orderId)) return;

		let ordersUrl = '/my/orders/#order-' + encodeURIComponent(orderId);
		if (!app.isAuthorized()) {
			window.location.href = '/auth/?backurl=' + encodeURIComponent(ordersUrl);

			return;
		}

		window.location.href = ordersUrl;
	},

	/**
	 * Неизвестное payload.value не исполняем.
	 * @param {Object} data
	 */
	onPostMessage(data) {
		let payload = data.payload && typeof data.payload === 'object' ? data.payload : {};
		switch (payload.value) {
			default:
				return;
		}
	},
};
